import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=3e7219e4&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=3e7219e4&prod&lang=scss&scoped=true"
import style1 from "./teacher.vue?vue&type=style&index=1&id=3e7219e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7219e4",
  null
  
)

export default component.exports